export enum CargoReportEnum {
    CargoEvent = 1,
    NORTender = 2,
    PortLog = 3,
    ProtestDiff = 4,
    SlowRate = 5,
    DeadfreightClaim = 6,
    GeneralProtest = 7,
    InsufficientNumberOfHoses = 8,
    CertificateOfCleanliness = 9,
    EmptyTankCertificate = 10,
    UseOfVesselHoses = 11,
    ReTenderNOR = 12,
    CargoEventWithLaytime = 13,
    FreePratique = 14,
    CargoTemperatureLog = 15,
}
